import React, { useEffect, useRef, useState } from "react";

/*
 * Muted looping video behind a section. It only loads once the section is near the screen and only
 * plays while it is on screen. With reduced motion the poster stays.
 */
const BackgroundVideo = ({ src, poster, className = "", style }) => {
  const video = useRef(null);
  const [near, setNear] = useState(false);
  const [onScreen, setOnScreen] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setOnScreen(entry.isIntersecting);
        if (entry.isIntersecting) setNear(true);
      },
      { rootMargin: "200px 0px" }
    );
    observer.observe(video.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const el = video.current;
    const still = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (onScreen && near && !still) el.play().catch(() => {});
    else el.pause();
  }, [onScreen, near]);

  return (
    <video
      ref={video}
      className={className}
      style={style}
      src={near ? `${process.env.PUBLIC_URL}/${src}` : undefined}
      poster={`${process.env.PUBLIC_URL}/${poster}`}
      muted
      loop
      playsInline
      preload="none"
      aria-hidden="true"
    />
  );
};

export default BackgroundVideo;
